import { useContext } from "react";
import AppContext from "components/app/app-context";

export default () => useContext(AppContext).api;
